import styled from "styled-components";

export const SeleccionLaboratorioContainer = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;
export const SeleccionLaboratorioHeader = styled.div`
  padding: 52px 28px;
  display: flex;
  justify-content: center;
  span {
    color: var(--color-latex10);
    text-align: center;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .SeleccionLaboratorio-TitleBold {
    font-weight: bold;
  }
`;

export const SeleccionLaboratorioBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 282px;
`;

export const SeleccionLaboratorioGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
`;

export const SeleccionLaboratorioBotonAzul = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 540px;
  height: 72px;
  border-radius: 12px;
  cursor: pointer;

  ${({ selected }) =>
    selected
      ? `background: var(--color-primary);`
      : `background: var(
    --Grandiente-cards,
    linear-gradient(258deg, #027bc0 18.65%, #004b76 86.55%)
  );`}

  box-shadow: 3px 7px 11px 0px rgba(0, 0, 0, 0.25);
  span {
    color: var(--color-white);
    font-size: 18px;
    user-select: none;
    /* font-weight: 700; */
  }
`;

export const SeleccionLaboratorioFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 78px;
  .SeleccionLaboratorio-boton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 360px;
    height: 36px;
    border-radius: 12px;
    background-color: var(--color-primary);
    color: var(--color-white);
    cursor: pointer;
  }
`;
